export const unidadModel = {
  numero_unidad: "",
  cedis: "",
  negocio: "",
  unidad_disponible: "",
  unidad_id: "",
};
